import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useContext } from 'react';
import { useTransition, animated } from 'react-spring/web.cjs';
import { animationConfig } from '../animation/animationConfig.js';
import AnimationContext from '../AnimationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function OverflowList(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$activeHierarchy = _ref.activeHierarchy,
      activeHierarchy = _ref$activeHierarchy === void 0 ? '' : _ref$activeHierarchy,
      children = _ref.children;

  var _useContext = useContext(AnimationContext.Context),
      _useContext$state$isD = _useContext.state.isDrillingDown,
      isDrillingDown = _useContext$state$isD === void 0 ? false : _useContext$state$isD,
      setIsDrillingDown = _useContext.setIsDrillingDown;

  var overflowTransition = useTransition(activeHierarchy, null, _objectSpread(_objectSpread({}, animationConfig.moveList(isDrillingDown)), {}, {
    onDestroyed: function onDestroyed() {
      return setIsDrillingDown(false);
    }
  }));
  return overflowTransition.map(function (_ref2) {
    var props = _ref2.props,
        key = _ref2.key;
    return /*#__PURE__*/React.createElement(animated.div, {
      key: key,
      className: className,
      style: props
    }, children);
  });
}

export default OverflowList;
//# sourceMappingURL=OverflowList.js.map
